/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Header from './Header/index'
import Main from './Main/index'
import React from 'react'
import Tabs from './Tabs/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content"
  
}) {
  return (<React.Fragment
>
<Header
  viewPath={`${viewPath}/Header`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
</div>
<Main
  viewPath={`${viewPath}/Main`}
/>
{children}
</React.Fragment>)
}